import React, { useEffect, useState } from "react";
import { StyleSheet, View, StatusBar } from "react-native";
import * as SplashScreen from "expo-splash-screen";
import Screens from "./screens";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import { SCREEN_HEIGHT, SCREEN_WIDTH } from "./common";

function App() {
  const [isAppReady, setIsAppReady] = useState(false);

  const handleSplashScreen = async () => {
    try {
      await SplashScreen.preventAutoHideAsync();
      await new Promise((resolve) => {
        setTimeout(async () => {
          await SplashScreen.hideAsync();
          resolve();
        }, 2000);
      });
    } catch (e) {
    } finally {
      setIsAppReady(true);
    }
  };

  useEffect(() => {
    setIsAppReady(false);
    handleSplashScreen();
  }, []);

  if (!isAppReady) {
    return <StatusBar barStyle="dark-content" />;
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <View style={styles.container}>
          <View style={styles.content}>
            <StatusBar
              translucent={true}
              barStyle="dark-content"
              backgroundColor="#00000000"
            />
            <Screens />
          </View>
        </View>
      </PersistGate>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    height: SCREEN_HEIGHT,
    width: SCREEN_WIDTH,
    overflow: "hidden",
    backgroundColor: "#fff",
  },
});

export default App;
